import { styled } from '@mui/system'
import { Grid } from '@mui/material'

export const Wrapper = styled(Grid)(`
    
`)
